import SettingsTabBase from "./SettingsTabBase.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import {userPreferences} from "../../../react/context/bryntumContext.jsx";
import {eventStyles, MIXED_TASK_COLOR, MIXED_TASK_STYLE, STRIPED_TASK_STYLE} from "../../../other/constants/TaskTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS, TriggerKeyForStyleColor} from "../../../other/constants/OtherKeys.jsx";
import { capitalizeText } from "../../../other/utils/utils.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";

export default class SwivuSettingsTaskGeneralTab extends SettingsTabBase {
  static get $name() {
    return "SwivuSettingsTaskGeneralTab";
  }

  static get type() {
    return "swivusettingstaskgeneraltab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.taskGeneralTab;
  }

  static get configurable() {
    return {
      title: "Tasks General Settings",
      cls: "p-[1em]",
      defaults: {
        labelWidth: "10em",
      },
      items: {
        taskColorField: {
          type: WIDGET_KEYS.colorField,
          clearable: false,
          label: "Task Color",
          name: "taskColor",
          isEventColor: true,
          onChange: "up.onUpdateTaskSettings",
        },
        taskStyleField: {
          type: "combo",
          label: "Task Style",
          name: "taskStyle",
          items: ['mixed'].concat([...eventStyles, STRIPED_TASK_STYLE]),
          // listItemTpl: renderTaskSyleList,
          listItemTpl: (item) => capitalizeText(item.value),
          listCls: "board-task-style-list b-sch-horizontal",
          cls: "b-swivu-task-style",
          onChange: "up.onUpdateTaskSettings",
        }
      }
    }
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);
    const { taskColorField, taskStyleField } = this.widgetMap;
    const globalColor = userPreferences.getSetting("taskColor", MIXED_TASK_COLOR, true);
    const globalStyle = userPreferences.getSetting("taskStyle", MIXED_TASK_STYLE, true);
    taskColorField.value = globalColor;
    taskStyleField.value = globalStyle;
  }

  onUpdateTaskSettings({ source, userAction }) {
    if (userAction) {
      switch(source.name) {
        //Todo: Apply color change in plans View
        case "taskColor": {
          // Mixed option has array of colors therefore array check has been applied
          const color = Array.isArray(source.value) ? MIXED_TASK_COLOR : source.value;
          userPreferences.updateSetting("taskColor", String(color), true);
          userPreferences.trigger(TriggerKeyForStyleColor, {})
          break;
        }
        case "taskStyle": {
          userPreferences.updateSetting("taskStyle", String(source.value), true);
          userPreferences.trigger(TriggerKeyForStyleColor, {})
          break;
        }
      }
    }
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const { taskColorField, taskStyleField } = this.widgetMap;
      taskColorField.disabled = true;
      taskStyleField.disabled = true;
    }
  }
}

SwivuSettingsTaskGeneralTab.initClass();
